import { IconButtonProps } from '@material-ui/core';

export const iconButton: IconButtonProps = {
  color: 'primary',
  className: 'sg', // Override to resolve conflicts with IconButton and CheckBox
};
